module.exports = __webpack_public_path__ + "img/GHS04.f4ebca15.gif";